//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
  name: "MatrixFilter",
  props: ["data", "id"],
  computed: {
    ...mapGetters(["filters"]),
    selected() {
      if (this.filters[this.id]) {
        if (this.filters[this.id][this.data.tag]) return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(["loadFilters"]),
    select() {
      let payload = {
        id: this.id,
        tag: this.data.tag,
        data: this.data.values
      };
      this.loadFilters(payload);
    }
	}
};
